import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import JanicePfp from "./Avatars/JanicePfp.webp";
import SpamTextsProfilePic from "./Avatars/PlainAvatar.jpg";
import NeaPfp from "./Avatars/NeaPfp.webp";

import PregTest from "./TimeSquarePictures/PregTest.webp";
import LauraOhlman from "./TimeSquarePictures/laura-ohlman.webp";
import BankDeatils from "./TimeSquarePictures/BankDetails.webp";

export const TimeSquareMessageContent: Chat_content[] = [
  {
    icon: JanicePfp, // Assuming this points to the image file
    name: "Janice",
    type: "individual",
    read: false, // Adjusted based on whether the conversation was read
    messages: [
      {
        content: {
          type: "missed-call",
          content: "missed call from Janice, 6:57pm",
        },
        timestamp: "2024-08-18T18:57:00Z",
        from: "n/a",
        status: "Unread",
      },
      {
        content: {
          type: "missed-call",
          content: "missed call from Janice, 6:58pm",
        },
        timestamp: "2024-08-18T18:58:00Z",
        from: "n/a",
        status: "Unread",
      },
      {
        content: {
          type: "missed-call",
          content: "missed call from Janice, 6:59pm",
        },
        timestamp: "2024-08-18T18:59:00Z",
        from: "n/a",
        status: "Unread",
      },
      {
        content: {
          type: "text",
          content: "Shauna where are you?",
        },
        timestamp: "2024-08-18T18:59:00Z",
        from: "Janice",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "text me if you're safe",
        },
        timestamp: "2024-08-18T19:00:00Z",
        from: "Janice",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I've just got to Times Square and it's closed off I can't get through",
        },
        timestamp: "2024-08-18T19:01:00Z",
        from: "Janice",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "police are saying there's been a stampede",
        },
        timestamp: "2024-08-18T19:01:00Z",
        from: "Janice",
        status: "Read",
      },
    ],
  },
  {
    icon: SpamTextsProfilePic,
    name: "John",
    type: "individual",
    read: false,
    messages: [
      {
        content: {
          type: "photo",
          content: {
            image: PregTest,
            date: "1 Aug 2024",
            time: "8:45pm",
            location: "",
          },
        },
        timestamp: "2024-08-01T20:45:00Z",

        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "it's yours.",
        },
        timestamp: "2024-08-01T20:46:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "missed-call",
          content: "missed call from John, 8:46pm",
        },
        timestamp: "2024-08-01T20:46:00Z",
        from: "n/a",
        status: "Unread",
      },
      {
        content: {
          type: "missed-call",
          content: "missed call from John, 8:46pm",
        },
        timestamp: "2024-08-01T20:46:00Z",
        from: "n/a",
        status: "Unread",
      },
      {
        content: {
          type: "text",
          content: "Oh my god",
        },
        timestamp: "2024-08-01T20:46:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Is it mine?",
        },
        timestamp: "2024-08-01T20:46:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Shauna please you have to get an abortion",
        },
        timestamp: "2024-08-01T20:46:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Seriously its not funny",
        },
        timestamp: "2024-08-01T20:47:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I'll do anything Shauna you have to get an abortion",
        },
        timestamp: "2024-08-01T20:48:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Shauna",
        },
        timestamp: "2024-08-01T21:01:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "yes of course it's yours",
        },
        timestamp: "2024-08-01T21:03:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "What will you do for me?",
        },
        timestamp: "2024-08-01T21:03:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I have money",
        },
        timestamp: "2024-08-01T21:03:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I'll buy you anything",
        },
        timestamp: "2024-08-01T21:03:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Did you get my gift box?",
        },
        timestamp: "2024-08-07T15:46:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "It says it was delivered",
        },
        timestamp: "2024-08-07T15:46:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes I got it",
        },
        timestamp: "2024-08-07T16:13:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: {
            image: LauraOhlman,
            date: "7 Aug 2024",
            time: "4:14pm",
            location: "",
          },
        },
        timestamp: "2024-08-07T16:14:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Well? Have you thought over your decision?",
        },
        timestamp: "2024-08-07T16:13:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes I am still deciding to keep the baby",
        },
        timestamp: "2024-08-07T16:16:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "and I will tell your wife about you and me",
        },
        timestamp: "2024-08-07T16:16:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "unless you give me $30,000",
        },
        timestamp: "2024-08-07T16:17:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "$30,000 are you kidding me??",
        },
        timestamp: "2024-08-07T16:18:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "do you want the baby or not?",
        },
        timestamp: "2024-08-07T16:18:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: {
            image: BankDeatils,
            date: "7 Aug 2024",
            time: "4:19pm",
            location: "",
          },
        },
        timestamp: "2024-08-07T16:20:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I've already spent $3,000 on you with all these gifts",
        },
        timestamp: "2024-08-07T16:20:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "it's $30,000 or I'm having the baby",
        },
        timestamp: "2024-08-07T16:22:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I can't believe you. You won't believe what I'll do if I get my hands on you",
        },
        timestamp: "2024-08-07T16:26:00Z",
        from: "John",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "lucky for me you won't find me",
        },
        timestamp: "2024-08-07T16:28:00Z",
        from: "Shauna",
        status: "Read",
      },
    ],
  },
  {
    icon: NeaPfp, // Assuming this points to the image file
    name: "Nea",
    type: "individual",
    read: false,
    messages: [
      {
        content: {
          type: "text",
          content: "I have some exciting news",
        },
        timestamp: "2024-07-30T10:46:00Z",

        from: "Nea",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Omg tell me!! What is it???!??!",
        },
        timestamp: "2024-07-30T10:48:00Z",
        from: "Shauna",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: {
            image: PregTest,
            date: "30 July 2024",
            time: "10:49am",
            location: "",
          },
        },
        timestamp: "2024-07-30T10:49:00Z",
        from: "Nea",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I'm pregnant!",
        },
        timestamp: "2024-07-30T10:49:00Z",
        from: "Nea",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "No waaaaay!! Congratulations girl!! So happy for you and Daddy Raymond",
        },
        timestamp: "2024-07-30T10:50:00Z",
        from: "Shauna",
        status: "Read",
      },
    ],
  },
];
